import Page from "components/Layout/Page/Page";
import { Stack, IconButton } from "@mui/material";
import { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Cnpj from "./Cnpj/Cnpj";
import LinkCnpjClientCode from "./LinkCnpjClientCode/LinkCnpjClientCode";
import { useHistory } from "react-router-dom";

export default function LinkCnpj() {
  const [stepLinkCnpj, setStepLinkCnpj] = useState("cnpj");
  const [cnpj, setCnpj] = useState("");

  const router = useHistory();

  const steps = {
    cnpj: (
      <Cnpj
        onSuccess={(cnpj) => {
          setCnpj(cnpj);
          setStepLinkCnpj("clientCode");
        }}
      />
    ),
    clientCode: <LinkCnpjClientCode cnpj={cnpj} />,
  };

  return (
    <Page>
      <Stack
        justifyContent={"center"}
        alignItems="center"
        height="100vh"
        textAlign={"center"}
      >
        <IconButton
          onClick={() => {
            if (stepLinkCnpj === "cnpj") return router.push("/my-cnpjs");
            setStepLinkCnpj("cnpj");
          }}
          sx={{ position: "absolute", p: 0, top: 60, left: 100 }}
        >
          <ArrowBackIcon sx={{ color: "#fff", fontSize: "31px" }} />
        </IconButton>

        <Stack
          width={"100%"}
          justifyContent={"center"}
          alignItems={"center"}
          maxWidth={"660px"}
        >
          {steps[stepLinkCnpj]}
        </Stack>
      </Stack>
    </Page>
  );
}
